import { c as _objectWithoutProperties, d as _objectSpread2 } from './_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.starts-with.js';
import { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import memoize from '../global/memoize.js';
import { jsx } from 'react/jsx-runtime';

var modules_29747b80 = {"light":"light_rui_2ac4","icon":"icon_rui_c997","glyph":"glyph_rui_c997","compatibilityMode":"compatibilityMode_rui_c997","gray":"gray_rui_c997","hover":"hover_rui_c997","green":"green_rui_c997","magenta":"magenta_rui_c997","red":"red_rui_c997","blue":"blue_rui_c997","white":"white_rui_c997","loading":"loading_rui_c997","icon-loading":"icon-loading_rui_c997"};

var _excluded = ["src", "className"];
function convertReactSVGDOMProperty(str) {
  return str.replace(/[-|:]([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}
function serializeAttrs(map) {
  var res = {};
  for (var i = 0; i < map.length; i++) {
    var key = map[i].name;
    var prop = key;
    if (key === 'class') {
      prop = 'className';
    } else if (!key.startsWith('data-')) {
      prop = convertReactSVGDOMProperty(key);
    }
    res[prop] = map[i].value;
  }
  return res;
}
function extractSVGProps(svgNode) {
  var map = svgNode.attributes;
  return map.length > 0 ? serializeAttrs(map) : null;
}
var getSVGFromSource = memoize(function (src) {
  var svgContainer = document.createElement('div');
  svgContainer.innerHTML = src;
  var svg = svgContainer.firstElementChild;
  svg.remove ? svg.remove() : svgContainer.removeChild(svg);
  return {
    props: extractSVGProps(svg),
    html: svg.innerHTML
  };
});
function isCompatibilityMode(iconSrc) {
  var hasWidth = /width="[\d\.]+"/ig.test(iconSrc);
  var hasHeight = /height="[\d\.]+"/ig.test(iconSrc);
  return !hasWidth || !hasHeight;
}
function IconSVG(_ref) {
  var src = _ref.src,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var glyphClasses = classNames(modules_29747b80.glyph, {
    [modules_29747b80.compatibilityMode]: isCompatibilityMode(src)
  }, className);
  var _getSVGFromSource = getSVGFromSource(src),
    props = _getSVGFromSource.props,
    html = _getSVGFromSource.html;
  return /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2(_objectSpread2({}, props), rest), {}, {
    className: glyphClasses,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }));
}
IconSVG.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  style: PropTypes.object
};
var IconSVG$1 = /*#__PURE__*/memo(IconSVG);

export { IconSVG$1 as I, modules_29747b80 as m };
